import { getAuth } from "@firebase/auth";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import CreateExam from "../../../../../Controllers/Admin/Exams/CreateExam";
import GetSingleExam from "../../../../../Controllers/Admin/Exams/GetSingleExam";
import UpdateExam from "../../../../../Controllers/Admin/Exams/UpdateExam";

export default function AddExamViewModel() {
  const navigate = useNavigate();
  const location = useLocation();
  const [ClassID, setClassID] = useState("");
  const [CourseID, setCourseID] = useState("");
  const [ExamID, setExamID] = useState("");

  useEffect(() => {
    const LocationArray = location.pathname.split("/");
    if (LocationArray.includes("update")) {
      setClassID(LocationArray.slice(-6, -5)[0]);
      setCourseID(LocationArray.slice(-4, -3)[0]);
    } else {
      setClassID(LocationArray.slice(-5, -4)[0]);
      setCourseID(LocationArray.slice(-3, -2)[0]);
    }
  }, [location?.pathname]);

  const [AuthUser, setAuthUser] = useState();

  const [ExamNameError, setExamNameError] = useState(false);
  const [ExamDescriptionError, setExamDescriptionError] = useState(false);
  const [ExamTotalMarksError, setExamTotalMarksError] = useState(false);
  const [ExamDateError, setExamDateError] = useState(false);
  const [ExamStartTimeError, setExamStartTimeError] = useState(false);
  const [ExamEndTimeError, setExamEndTimeError] = useState(false);

  const [FormDisabled, setFormDisabled] = useState(false);
  const [IsUpdate, setIsUpdate] = useState(false);

  const [IsCheckError, setIsCheckError] = useState(false);
  const [AddExam, setAddExam] = useState({
    ExamName: "",
    ExamDescription: "",
    ExamDate: "",
    ExamStartTime: "",
    ExamEndTime: "",
  });

  useEffect(() => {
    const LocationArray = location.pathname.split("/");
    setExamID(LocationArray.pop());

    if (LocationArray.includes("update")) {
      setIsUpdate(true);
      const fetchData = async () => {
        const ExamData = await GetSingleExam(ExamID);
        setAddExam({
          ExamName: ExamData?.ExamName,
          ExamDescription: ExamData?.ExamDescription,
          ExamTotalMarks: ExamData?.ExamTotalMarks,
          ExamDate: ExamData?.ExamDate,
          ExamStartTime: ExamData?.ExamStartTime,
          ExamEndTime: ExamData?.ExamEndTime,
        });
      };
      fetchData();
    } else {
    }
  }, [location.pathname, ExamID]);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        setAuthUser(user);
      });
    }
    fetchData();
  }, []);

  const UIErrorHandling = useCallback(() => {
    let flag = 0;

    if (
      AddExam.ExamName === "" ||
      AddExam.ExamName === null ||
      AddExam.ExamName === undefined ||
      AddExam.ExamName.length < 3
    ) {
      setExamNameError(true);
      flag++;
    } else {
      setExamNameError(false);
    }

    if (
      AddExam.ExamDescription === "" ||
      AddExam.ExamDescription === null ||
      AddExam.ExamDescription === undefined ||
      AddExam.ExamDescription.length < 3
    ) {
      setExamDescriptionError(true);
      flag++;
    } else {
      setExamDescriptionError(false);
    }

    if (
      AddExam.ExamTotalMarks === "" ||
      AddExam.ExamTotalMarks === null ||
      AddExam.ExamTotalMarks === undefined
    ) {
      setExamTotalMarksError(true);
      flag++;
    } else {
      setExamTotalMarksError(false);
    }

    if (
      AddExam.ExamDate === "" ||
      AddExam.ExamDate === null ||
      AddExam.ExamDate === undefined
    ) {
      setExamDateError(true);
      flag++;
    } else {
      setExamDateError(false);
    }

    if (
      AddExam.ExamStartTime === "" ||
      AddExam.ExamStartTime === null ||
      AddExam.ExamStartTime === undefined
    ) {
      setExamStartTimeError(true);
      flag++;
    } else {
      setExamStartTimeError(false);
    }

    if (
      AddExam.ExamEndTime === "" ||
      AddExam.ExamEndTime === null ||
      AddExam.ExamEndTime === undefined
    ) {
      setExamEndTimeError(true);
      flag++;
    } else {
      setExamEndTimeError(false);
    }

    return flag;
  }, [
    AddExam.ExamName,
    AddExam.ExamDescription,
    AddExam.ExamTotalMarks,
    AddExam.ExamDate,
    AddExam.ExamStartTime,
    AddExam.ExamEndTime,
  ]);

  useEffect(() => {
    if (IsCheckError) UIErrorHandling();
  }, [IsCheckError, UIErrorHandling]);

  const RegisterExam = async () => {
    setIsCheckError(true);
    let flag = 0;
    flag = UIErrorHandling();

    if (flag === 0) {
      setFormDisabled(true);
      if (IsUpdate) {
        const ExamFinalObject = {
          ...AddExam,
        };

        await UpdateExam(ExamFinalObject, ExamID)
          .then(() => {
            navigate(-1);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        const ExamFinalObject = {
          ...AddExam,
          Class: ClassID,
          Course: CourseID,
        };
        await CreateExam(ExamFinalObject, AuthUser.uid)
          .then(() => {
            navigate(-1);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      setFormDisabled(false);
    }
  };

  return {
    RegisterExam,
    AddExam,
    setAddExam,
    ExamNameError,
    ExamDescriptionError,
    ExamTotalMarksError,
    ExamDateError,
    ExamStartTimeError,
    ExamEndTimeError,
    FormDisabled,
  };
}
